/* eslint-disable react-hooks/exhaustive-deps */

import { RoutesTableTrip, Title } from "@components";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Notification, TableSearch } from "@rio-cloud/rio-uikit";

import { useDebounce } from "src/hooks/useDebounce";
import {
  excludeRoute,
  fetchRoutesList,
} from "src/services/routes";
import PageContainer from "../../components/routes/PageContainer";

import {
  setIdRouteSelected,
} from "@store";


const PAGE_SIZE = 10;

export interface IVehicle {
  id: string;
  name: string;
  accountId?: string;
  status?: string;
  type?: string;
  identification?: string;
  identificationType?: string;
  brand: string;
  licensePlate?: string;
  licensePlateCountryCode?: string;
  embedded?: null | string[];
  groupIds?: null | string[];
  nextMaintenanceKm?: string;
  odometer?: string;
  hourmeter?: string;
  latitude?: string;
  longitude?: string;
}

const TripsListRouteScreen = () => {
  const [routes, setRoutes] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sort, setSort] = useState("desc");
  const [fieldSort, setFieldSort] = useState("createdAt");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const debouncedSearch = useDebounce(searchValue, 400);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search] = useSearchParams();

  const currentParams = new URLSearchParams(search);

  const handleUpdateRoute = (id: string) => {
    currentParams.set("id", id);
    const url = "/routing/routes/update?" + currentParams.toString();
    navigate(url);
  };

  const initialData = async (pageToSearch?: number, signal?: AbortSignal, search = debouncedSearch) => {
    try {
      const res = await fetchRoutesList(
        1,
        page === 0 ? PAGE_SIZE : page * PAGE_SIZE,
        search,
        sort,
        fieldSort,
        { signal }
      );

      if (res.data.result.routes) {
        setRoutes(res.data.result.routes);
        setPages(res.data.result.pages);
      }
    } catch (error) {
      if ((error as any).name !== "CanceledError")
        Notification.error("Não foi possível buscar as rotas.");
    } finally {
      if (pageToSearch) {
        setPage(pageToSearch);
      }
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    initialData(undefined, signal);
    return () => {
      controller.abort();
    };
  }, [page, debouncedSearch, sort]);

  const handleDeleteRoute = async (id: string) => {
    try {
      await excludeRoute(id);
      Notification.info("Rota excluída com sucesso!");
      initialData(page > 1 && routes.length === 1 ? page - 1 : page);
    } catch (error) {
      Notification.error("Erro ao excluir rota!");
    }
  };

  const handleSelectedRoute = (id: string) => {
    const currentParams = new URLSearchParams(search);
    currentParams.set('id', id);
    currentParams.set("trip", 'true');
    dispatch(setIdRouteSelected(id));
    const url = "/routing/trips/schedule?" + currentParams.toString();
    navigate(url);
  }

  return (
    <PageContainer>
      <div>
        <Title
          icon="rioglyph rioglyph-route-option"
          title="Selecionar rota para a viagem"
        />
      </div>

      <div>
        <TableSearch
          value={searchValue}
          onChange={(text) => setSearchValue(text)}
          placeholder="Buscar em rotas"
        />
      </div>

      <RoutesTableTrip
        pageSize={PAGE_SIZE}
        handleSelect={handleSelectedRoute}
        pages={pages}
        handleSort={(dir, field) => {
          setSort(dir);
          setFieldSort(field);
        }}
        routes={routes}
        viewType="TABLE"
        page={page}
        handleUpdateRoute={handleUpdateRoute}
        handleSearchValueChange={(text) => setSearchValue(text)}
        handleDeleteRoute={handleDeleteRoute}
        searchValue={searchValue}
        handlePage={params => {
          setPage(params.page);
        }}
      />
    </PageContainer>
  );
};

export default TripsListRouteScreen;
